import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;
const ClubManagement = () => {


    const table1 = useRef(null);
    const table2 = useRef(null);
    const table3 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11, table12, table13;

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }

        if (table2.current) {
            table12 = $(table2.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        if (table3.current) {
            table13 = $(table3.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
            if (table12) table12.destroy();
            if (table13) table13.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Club Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Club Management</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#create_plan" className="d-flex align-items-center btn btn-primary font-18 ms-auto mb-3" style={{ width: 'fit-content' }}>
                        <i className="bx bx-plus ms-1" /> <span>Add</span>
                    </Link>
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs inner-tab">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="all-tabs" data-bs-toggle="tab" data-bs-target="#allTab" type="button" role="tab">All</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pending-tabs" data-bs-toggle="tab" data-bs-target="#pendingTab" type="button" role="tab">Pending</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="onboarded-tabs" data-bs-toggle="tab" data-bs-target="#onboardedTab" type="button" role="tab">Approved</button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="allTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table1} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Club Name</th>
                                                    <th>Club Director</th>
                                                    <th>Teams Count</th>
                                                    <th>Country</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Brooklyn Strikers</td>
                                                    <td>Robert Sean</td>
                                                    <td>20</td>
                                                    <td>USA</td>
                                                    <td>Pending</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Liberty United FC</td>
                                                    <td>John Clark</td>
                                                    <td>55</td>
                                                    <td>USA</td>
                                                    <td>Approved</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>London Royals</td>
                                                    <td>Richard Thomas</td>
                                                    <td>30</td>
                                                    <td>United Kingdom</td>
                                                    <td>Decline</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pendingTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table2} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Club Name</th>
                                                    <th>Club Director</th>
                                                    <th>Teams Count</th>
                                                    <th>Country</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Brooklyn Strikers</td>
                                                    <td>Robert Sean</td>
                                                    <td>20</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Liberty United FC</td>
                                                    <td>John Clark</td>
                                                    <td>55</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>London Royals</td>
                                                    <td>Richard Thomas</td>
                                                    <td>30</td>
                                                    <td>United Kingdom</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="onboardedTab" role="tabpanel">
                                    <div className="table-responsive">
                                        <div className="entries-wrapper mb-3">
                                            <label className="entries-label">
                                                <span>Showing</span>
                                                <select className="entries-select">
                                                    <option value={10} selected>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </select>
                                                <span>Entries</span>
                                            </label>
                                        </div>
                                        <table ref={table3} className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Club Name</th>
                                                    <th>Club Director</th>
                                                    <th>Teams Count</th>
                                                    <th>Country</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Brooklyn Strikers</td>
                                                    <td>Robert Sean</td>
                                                    <td>20</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Liberty United FC</td>
                                                    <td>John Clark</td>
                                                    <td>55</td>
                                                    <td>USA</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>London Royals</td>
                                                    <td>Richard Thomas</td>
                                                    <td>30</td>
                                                    <td>United Kingdom</td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start">
                                                            <li>
                                                                <Link to="/club-management-detail" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" title="View" className="lni lni-eye" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#approve_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-check-circle" aria-label="Approve" data-bs-original-title="Approve" />
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#decline_club_modal" type="button">
                                                                    <i data-bs-toggle="tooltip" data-bs-placement="top" className="bx bx-x-circle" aria-label="Decline" data-bs-original-title="Decline" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="create_plan" tabIndex={-1} aria-labelledby="createPlanModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Create New Club</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="edit_inp">
                                        <label>Club Name</label>
                                        <input type="text" name="name" placeholder="Enter Club Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="edit_inp">
                                        <label>Club Director</label>
                                        <input type="text" name="director" placeholder="Enter Club Director" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="edit_inp">
                                        <label>Teams Count</label>
                                        <input type="text" name="teams" placeholder="Enter Teams Count" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="edit_inp">
                                        <label>Country</label>
                                        <input type="text" name="country" placeholder="Enter Country" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> */}
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="approve_club_modal" tabIndex={-1} aria-labelledby="ApproveClubModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="ApproveClubModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to approve this club?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="decline_club_modal" tabIndex={-1} aria-labelledby="DeclineClubModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="DeclineClubModalLabel">Confirmation Alert!</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <h5>Do you want to decline this club?</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ClubManagement